export * from "is-thenable";
